export type IkasAvailableShippingMethod = {
  price: number;
  rateName: string;
  shippingMethod: IkasShippingMethod;
  shippingSettingsId: string;
  shippingZoneRateId: string;
};

export enum IkasShippingMethod {
  CLICK_AND_COLLECT = "CLICK_AND_COLLECT",
  NO_SHIPMENT = "NO_SHIPMENT",
  SHIPMENT = "SHIPMENT",
}
